'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import { PREMIERE_APP_ROUTES } from '~/constants/premiereAppRoutes';
import { useURLWorkspaceId } from '~/hooks/url/useURLWorkspaceId';

const WorkspaceRootPage = () => {
  const router = useRouter();
  const workspaceId = useURLWorkspaceId();

  useEffect(() => {
    if (workspaceId) {
      router.replace(PREMIERE_APP_ROUTES.ALL(workspaceId));
    }
  }, [workspaceId, router]);

  return null;
};
export default WorkspaceRootPage;
